import 'moment/locale/id';
import 'rc-input-number/assets/index.css';
import React from 'react';
import Select from 'react-select';
import "react-toggle/style.css";
import { Card } from 'reactstrap';
import { ResponsiveContainer } from 'recharts';
import { safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';
import { isFunction } from 'iotera-base/object';
import blank from '../../../../icons/blank.PNG';
import Textfit from '../../../../react/react-textfit/lib/Textfit';
import SendIcon from '@material-ui/icons/Send';
import IconButton from '@material-ui/core/IconButton';

/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../../../react/react-confirm-alert';


import IoteraClass from '../../../../react/react-class';

import CSVReader from 'react-csv-reader'

const PapaParse = require('papaparse/papaparse.min.js');
export class UploadCSVCard extends IoteraClass {
    constructor(props) {
        super(props);
        this.state = {
            selectedDeviceId: '',
            value: null,
            csvFile: [],
            csvFile: ''
        }
        this.handleClick = this.handleClick.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleClick = () => event => {
        let handleUploadCsv = safeDeepGet(this, ['props', 'handleUploadCsv']);
        let cardId = safeDeepGetWithType(this, ['props', 'id'], '');
        let csvFile = safeDeepGetWithType(this, ['state', 'csvFile'], []);

        if (isFunction(handleUploadCsv)) {
            let id = safeDeepGetWithType(this, ['state', 'selectedDeviceId'], '');
            let param = {
                deviceId: id,
                value: csvFile
            }
            if (id !== '')
                ioteraConfirmAlert(
                    'Konfirmasi',
                    'Apakah anda yakin ingin mengirim file CSV ini?',
                    'Ya, yakin',
                    () => handleUploadCsv(cardId, param),
                    null,
                    null
                )
            else
                ioteraConfirmAlert(
                    'Error!',
                    'Harus memilih satu perangkat yang akan dikonfigurasi',
                    'gone',
                    null,
                    'Ok',
                    null
                )
        }
    }

    handleChange = event => {
        let value = event.target.value;
        this.setState({
            value
        })
    }

    handleSelect = () => event => {
        if (event !== null) {
            let selectedDeviceId = event.value

            let handleDropdown = safeDeepGet(this, ['props', 'handleDropdown']);
            let cardId = safeDeepGetWithType(this, ['props', 'id'], '');
            let param = {
                deviceId: selectedDeviceId
            }
            if (isFunction(handleDropdown)) {
                handleDropdown(cardId, param)
            }

            this.setState({
                selectedDeviceId
            })
        } else {
            this.setState({
                selectedDeviceId: '',
                value: 0
            })
        }
    }

    handleChangeFile = e => {
        let reader = new FileReader();
        if (e.target.files.length > 0) {
            const _filename = e.target.files[0].name;

            reader.onload = event => {
                const csvData = PapaParse.parse(
                    event.target.result,
                    Object.assign({}, {
                        encoding: 'UTF-8'
                    })
                );
                let data = safeDeepGetWithType(csvData, ['data'], []);

                this.setState({ csvName: _filename, csvFile: data })
            };

            reader.readAsText(e.target.files[0], 'UTF-8');
        }
    };

    handleForce = (event) => {
        this.setState({ csvFile: event })
    }

    handleDarkSideForce = (event) => {
    }

    getFile = event => {
    }

    render() {
        let title = safeDeepGetWithType(this, ['props', 'title'], '');
        let defaults = safeDeepGetWithType(this, ['props', 'default_value'], '');
        if (title === '') {
            title = "Kirim perintah"
        }
        let button_label = safeDeepGetWithType(this, ['props', 'button_label'], '');
        if (button_label === '') {
            button_label = "Kirim"
        }
        let status = safeDeepGetWithType(this, ['props', 'status'], '');
        if (status === '') {
            status = 'Input Relay dalam detik'
        }
        let pict = safeDeepGetWithType(this, ['props', 'pict'], '');
        if (pict === '') {
            pict = blank;
        }


        let cardHeight = safeDeepGetWithType(this, ['props', 'cardHeight'], 130);
        let responsiveHeight = cardHeight - 35 - 26; // 35 is papdding top and bottom, and 26 is height of title

        let devices = [
            { "device_id": "cd0b2b14-e3b8-4dba-abcd-05e088317f45", "label": "Dummy Device 1" },
            { "device_id": "4a814f77-c47b-47fb-9233-0b6865c81365", "label": "Dummy Device 2" },
            { "device_id": "e0517a38-1427-482a-9e35-cb10615926e9", "label": "Uji Coba" },
            { "device_id": "60a66d86-d1c7-4633-be63-17823e4f4117", "label": "Dummy Device 4" },
            { "device_id": "3efe33f9-822d-4045-96b8-71d3583855b2", "label": "Dummy 1" }
        ]

        let deviceList = devices;
        let dropdownItem = []

        for (let j = 0; j < deviceList.length; j++) {
            let device = deviceList[j];

            let deviceId = safeDeepGetWithType(device, ['device_id'], '');
            let label = safeDeepGetWithType(device, ['label'], '');

            if ((deviceId !== '') && (label !== '')) {
                dropdownItem.push(
                    { label: label, value: deviceId }
                )
            }
        }
        let fileName = safeDeepGetWithType(this, ['state', 'csvName'], '');
        let label = fileName === '' ? 'Upload CSV' : fileName
        return (
                <React.Fragment className='align-items-start' style={{ padding: '17.5px', minHeight: cardHeight, maxHeight: cardHeight }}>
                    <div className='io-row' style={{ margin:0, marginTop: 10 }}>
                        <div /* className="col-sm-12 " */ >
                            <Textfit height={20} mode="single" max={12} className="h5" style={{ textTransform: 'capitalize', color: '#000', marginBottom: 0 }}>
                                <img src={pict} alt='icon' style={{ height: '26px', marginRight: 5 }} />{title}
                            </Textfit>
                        </div>
                    </div>

                    <ResponsiveContainer height={responsiveHeight} className='centeringItem'  >
                        <div style={{ minWidth: '100%' }}>
                            <div className='row centeringItem' style={{ minWidth: '100%', margin: 0 }}>
                                <div className='col-sm-5' style={{ marginBottom: '10px' }}>
                                    <Select styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} menuPortalTarget={document.body}
                                        ref="selectComponent"
                                        closeMenuOnSelect={true}
                                        defaultValue={[]}
                                        isClearable
                                        placeholder="Perangkat"
                                        name="colors"
                                        isSearchable
                                        isMulti={false}
                                        options={dropdownItem}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        onChange={this.handleSelect()}
                                    />
                                </div>
                                <div className='col-sm-5' style={{ marginTop: '2px' }}>
                                    {label &&
                                        <label className={`button-iotera-primary-outline text`} >{label}
                                            <input
                                                type="file"
                                                accept={`.csv, text/csv`}
                                                onChange={e => this.handleChangeFile(e)}
                                            />
                                        </label>}
                                </div>
                                <div className='col-sm-2' style={{ marginBottom: '10px' }}>
                                    <IconButton color="inherit" aria-label="Menu" onClick={this.handleClick()}>
                                        <SendIcon style={{ height: 14, width: 14 }} />
                                    </IconButton>
                                </div>
                            </div>
                        </div>
                    </ResponsiveContainer>
                </React.Fragment>
        );
    }
}